// extracted by mini-css-extract-plugin
export default {"container":"fk-z","blurb":"gk-z","links":"hk-z"};